"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApproverTypeEnum = void 0;
var ApproverTypeEnum;
(function (ApproverTypeEnum) {
    ApproverTypeEnum["USER"] = "USER";
    ApproverTypeEnum["RESPONSIBLE_USER"] = "RESPONSIBLE_USER";
    ApproverTypeEnum["SUPERIOR"] = "SUPERIOR";
    ApproverTypeEnum["AUTO_APPROVER"] = "AUTO_APPROVER";
    ApproverTypeEnum["FALLBACK_APPROVER"] = "FALLBACK_APPROVER";
    ApproverTypeEnum["REQUESTER"] = "REQUESTER";
})(ApproverTypeEnum || (exports.ApproverTypeEnum = ApproverTypeEnum = {}));
